import React, { useEffect } from 'react';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import { actionCreators as authActions } from '../redux/actions/authActions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { makeStyles } from '@material-ui/styles';
import { useParams } from 'react-router-dom';

class Legal extends React.Component {
    constructor(props) {
        super(props);

        if (this.props.setUseDefaultLogo) {
            this.props.setUseDefaultLogo({ wait: true, useDefault: undefined });
        }

        this.state = {
            legalTextTitle: '',
            legalTextContent: ''
        }

        this.classes = makeStyles({
            root: {
                minWidth: 275,
                maxHeight: '350px',
                overflow: 'auto',
            },
            consentTermText: {
                fontSize: 14,
            },
        });
    }

    componentDidMount() {
        this.getLegalText();
    }

    getLegalText = () => {
        const legalTextID = this.props.match.params.id;

        this.props
            .getLegalText(legalTextID)
            .then((result) => {
                this.setState((state) => ({
                    ...state,
                    errorMessage: '',
                    legalTextTitle: result.Title,
                    legalTextContent: result.HtmlContent
                }));

                if (this.props.setUseDefaultLogo) {
                    this.props.setUseDefaultLogo({ wait: false, useDefault: result.IsSystem });
                }
            })
            .catch((error) => {
                var errorMessage = error?.errorMessage ? error?.errorMessage : 'An unknown error has occurred. Please try again later or contact us for assistance.';
                this.setState((state) => ({
                    ...state,
                    errorMessage: errorMessage,
                    legalTextTitle: '',
                    legalTextContent: ''
                }));
            });
    }

    render() {
        return (
            <div style={{ minHeight: `90%`, minWidth: `90%` }}>
                <div style={{ marginTop: 20, textAlign: `center` }}>
                    <Typography variant='h4' component='h2' color='primary'>
                        {this.state.legalTextTitle}
                    </Typography>
                </div>
                <Card className={this.classes.root}>
                    <CardContent>
                        <Typography size="lg" style={{ overflowWrap: "anywhere", width: '100%' }}  dangerouslySetInnerHTML={{ __html: this.state.legalTextContent }} />
                    </CardContent>
                </Card>
            </div>
        );
    }
}

export default connect(
    (state) => state.authentication,
    (dispatch) => bindActionCreators(authActions, dispatch)
)(Legal);
